module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner8.e14e9fb5.jpg";